
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
} from 'Models/Model';
import * as Models from 'Models/Entities';
import { IAcl } from '../Security/IAcl';
import { observable } from 'mobx';
import UserUserReferenceManyToMany from '../Security/Acl/UserUserReferenceManyToMany';
import VisitorsUserReferenceManyToMany from '../Security/Acl/VisitorsUserReferenceManyToMany';


export interface IBusinessEntityUserAttributes extends IModelAttributes {
	businessEntityId: string;
	userId: string;

	businessEntity: Models.BusinessEntity | Models.IBusinessEntityAttributes;
	user: Models.UserEntity | Models.IUserEntityAttributes;

}

@entity('BusinessEntityUser')
export default class BusinessEntityUser
	extends Model
	implements IBusinessEntityUserAttributes {
	public static acls: IAcl[] = [
		new UserUserReferenceManyToMany(),
		new VisitorsUserReferenceManyToMany(),

	];

	@observable
	@attribute()
	public businessEntityId: string;

	@observable
	@attribute()
	public userId: string;

	@observable
	@attribute({ isReference: true })
	public businessEntity: Models.BusinessEntity;

	@observable
	@attribute({ isReference: true })
	public user: Models.UserEntity;


	constructor(attributes?: Partial<IBusinessEntityUserAttributes>) {

		super(attributes);

		if (attributes) {
			if (attributes.businessEntityId) {
				this.businessEntityId = attributes.businessEntityId;
			}
			if (attributes.userId) {
				this.userId = attributes.userId;
			}

			if (attributes.businessEntity) {
				if (attributes.businessEntity instanceof Models.BusinessEntity) {
					this.businessEntity = attributes.businessEntity;
					this.businessEntityId = attributes.businessEntity.id;
				} else {
					this.businessEntity = new Models.BusinessEntity(attributes.businessEntity);
					this.businessEntityId = this.businessEntity.id;
				}
			} else if (attributes.businessEntityId !== undefined) {
				this.businessEntityId = attributes.businessEntityId;
			}

			if (attributes.user) {
				if (attributes.user instanceof Models.UserEntity) {
					this.user = attributes.user;
					this.userId = attributes.user.id;
				} else {
					this.user = new Models.UserEntity(attributes.user);
					this.userId = this.user.id;
				}
			} else if (attributes.userId !== undefined) {
				this.userId = attributes.userId;
			}
		}

	}


}
